import {
    ADD_THEME,
    ADD_THEME_SUCCESS,
    ADD_THEME_FAILURE,
    THEMES_LIST,
    THEMES_LIST_SUCCESS,
    THEMES_LIST_FAILURE,
    UPDATE_THEME_STATUS,
    UPDATE_THEME_STATUS_SUCCESS,
    UPDATE_THEME_STATUS_FAILURE,
    EDIT_THEME,
    EDIT_THEME_SUCCESS,
    EDIT_THEME_FAILURE,
    UPDATE_THEME_ORDER_STATUS,
    UPDATE_THEME_ORDER_STATUS_FAILURE,
    UPDATE_THEME_ORDER_STATUS_SUCCESS,
    DELETE_THEME,
    DELETE_THEME_SUCCESS,
    DELETE_THEME_FAILURE
} from "../Constants";

const init = {
    data: {},
    add_data: {},
    edit_data: {},
    delete_data: {},
};

const ThemeListReducer = (state = init, action) => {
    switch (action.type) {
        case THEMES_LIST:
            return { ...state, loading: true };
        case THEMES_LIST_SUCCESS:
            return { ...state, loading: false, data: action.payload};
        case THEMES_LIST_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case ADD_THEME:
            return { ...state, loading: true };
        case ADD_THEME_SUCCESS:
            return { ...state, loading: false, add_data: action.payload};
        case ADD_THEME_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case UPDATE_THEME_STATUS:
            return { ...state, loading: true };
        case UPDATE_THEME_STATUS_SUCCESS:
            return { ...state, loading: false, update_data: action.payload };
        case UPDATE_THEME_STATUS_FAILURE:
            return { ...state, loading: false, update_data: action.payload };
        case EDIT_THEME:
            return { ...state, loading: true };
        case EDIT_THEME_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_THEME_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case UPDATE_THEME_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_THEME_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_data: action.payload };
        case UPDATE_THEME_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_data: action.payload };
        case DELETE_THEME:
            return { ...state, loading: true };
        case DELETE_THEME_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_THEME_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        default:
            return state;
    }
};



export default ThemeListReducer;